var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartSigningIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8504 7.00363C15.5363 6.31725 15.7368 5.28525 15.1681 4.49902C14.8034 3.99785 14.3995 3.52638 13.9603 3.08907C13.5229 2.64981 13.0515 2.24593 12.5503 1.88123C11.7641 1.31248 10.7321 1.51298 10.0457 2.19895L1.51806 10.7274C1.27875 10.9663 1.1211 11.2739 1.0916 11.6106C1.035 12.2526 0.974369 13.4822 1.09604 15.2269C1.10939 15.4152 1.19025 15.5924 1.32377 15.726C1.45729 15.8595 1.6345 15.9403 1.82285 15.9537C3.56791 16.0758 4.79717 16.0151 5.43909 15.9581C5.77581 15.9286 6.08343 15.771 6.32233 15.5317L14.8504 7.00363Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1519 8.2975C13.1519 8.2975 12.8996 7.17455 11.387 5.66192C9.87439 4.1501 8.75144 3.89746 8.75144 3.89746M5.87575 15.5736C5.87575 15.5736 5.62351 14.4507 4.11088 12.9381C2.59825 11.4262 1.4753 11.1736 1.4753 11.1736M1.02539 18.4497H10.7269C11.7765 18.4497 12.7977 18.1093 13.6374 17.4796L13.9607 17.237M13.9607 17.237L14.9309 16.5094C15.2024 16.3058 15.4029 16.0219 15.5041 15.698C15.6053 15.3741 15.602 15.0265 15.4947 14.7046C15.3874 14.3826 15.1815 14.1026 14.9062 13.9042C14.6309 13.7058 14.3001 13.599 13.9607 13.599C13.6214 13.599 13.2906 13.7058 13.0153 13.9042C12.74 14.1026 12.5341 14.3826 12.4268 14.7046C12.3195 15.0265 12.3162 15.3741 12.4174 15.698C12.5186 16.0219 12.7191 16.3058 12.9906 16.5094L13.9607 17.237ZM13.9607 17.237L14.9309 17.9647C15.3507 18.2795 15.8613 18.4497 16.3861 18.4497H18.4073",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartSigningIcon);
export default __webpack_public_path__ + "static/media/StartSigningIcon.3469c49b5df447672d18fb6cd489e7b7.svg";
export { ForwardRef as ReactComponent };